import React, { useContext, useState } from "react";
import { connect } from "react-redux";
import format from "date-fns/format";
import { TicketApi } from "services/ticket";
import { func, bool, string } from "prop-types";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { DeleteStorageDataContext } from "context/DeleteStorageContext";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { TYPES, SEVERITIES } from "utils/TicketConstants";
import { Utils } from "services/utils";
import { RESOLUTIONS } from "services/config";
import { StorageApi } from "services/storage";
import { ConfirmationScreen } from "styled_components/Common/ConfirmationScreen";
import { BloxButton } from "styled_components/Common/BloxButton";
import { useActiveScreen } from "hooks/useActiveScreen";
import { ConfirmScreenOne } from "./Screens/ConfirmScreenOne";
import { ConfirmScreenTwo } from "./Screens/ConfirmScreenTwo";

const SCREENS = {
  0: ConfirmScreenOne,
  1: ConfirmScreenTwo,
  2: ConfirmationScreen,
};

function getSize(breakpoint) {
  let size = "medium";
  if (breakpoint === RESOLUTIONS.MED) {
    size = "medium";
  } else if (breakpoint === RESOLUTIONS.HIGH) {
    size = "medium";
  }

  return size;
}

function checkValidation(activePage, inputs) {
  let valid = false;

  switch (activePage) {
    case 0:
      const location = inputs?.primaryLocation;
      if (location !== "") {
        valid = true;
      }
      break;
    case 1:
      const storageName = inputs?.share?.common_name;

      if (inputs?.name === storageName && !inputs.submitted) {
        return true;
      } else {
        return false;
      }

    case 2:
      if (inputs.submitted) {
        valid = false;
      } else {
        valid = true;
      }
      break;

    default:
      break;
  }
  return valid;
}
function getButtonText(inputs, activePage) {
  let text = "NEXT";

  switch (activePage) {
    case 0:
      text = "DELETE IT";

      break;
    case 1:
      text = "MAKE IT SO!";

      break;
    default:
      break;
  }
  return text;
}
function getButtonFunction(
  buttonText,
  activePage,
  setActivePageIndex,
  setModalContent,
  inputs,
  setCaseId,
  change,
  props,
  ticketType
) {
  if (activePage === 0) {
    if (buttonText === "REVIEW") {
      return () => setActivePageIndex(2);
    } else {
      return () => {
        change({ target: { name: "share", value: props?.share } });
        setActivePageIndex(activePage + 1);
      };
    }
  } else if (activePage === 1) {
    return () => {
      change({ target: { name: "submitted", value: true } });
      submit(
        setActivePageIndex,
        setModalContent,
        inputs,
        setCaseId,
        change,
        props,
        ticketType
      );
    };
  }
}

async function createDeleteStorageTicket(
  props,
  setModalContent,
  setCaseId,
  setActivePageIndex,
  button
) {
  const {
    site,
    company_info,
    auth_status,
    share,
    auth_status: {
      user: {
        userProfile: { emailAddress },
      },
    },
  } = props;

  const type = TYPES.STORAGE;
  const priority = SEVERITIES.LOW;
  const description = formatDeleteDescription(share, auth_status);
  const title = "Delete Storage";
  const storageDeleteId = share.storage_id;
  const browserInfo = await Utils.getClientParams(site);
  const userId = auth_status.user.id;
  const companyId = company_info?.customer?.id;
  const newTicket = {
    requester: Utils.getRequester(auth_status),
    requester_contact_type: "",
    requester_contact_value: emailAddress,
    internalTicketReference: "",
    requester_id: userId,
    record_id: share?.storage_id,
    invite_id: "",
    public_request: null,
    status: "New",
    title,
    description,
    priority,
    internal_priority: priority,
    type,
    request_type: type,
    request_method: "",
    service: "storage",
    process_id: 0,
    companyId,
    userId,
    jira_ticket: "",
    location: "",
    impact_to_customer: "None",
    impact_to_dcblox: "None",
    resolution_notes: "",
    general_support_question_type: "",
    general_support_question: "",
    general_support_equipment: "",
    feedback_type: "",
    feedback_browser_data: browserInfo,
    billing_detail: [],
    outage_details: [],
    related_tickets: [],
    assignes: [],
    request_log: [],
    comments: [],
    attachments: [],
    notifications: [],
    related_services: [],
    test_results: [],
    storageDeleteId,
  };

  TicketApi.createTicket(newTicket)
    .then((response) => {
      if (response.status === 200 && !response.data.error) {
        setActivePageIndex(2);
        setCaseId(response.data.caseId);
        sessionStorage.removeItem("tickets");
      } else {
        setModalContent(
          "TIMEOUT_CLOSE",
          "Network error deleting storage",
          button
        );
      }
    })
    .catch(() =>
      setModalContent("TIMEOUT_CLOSE", "Network error deleting storage", button)
    );
}

function formatDeleteParams(props) {
  const {
    user: { firstname, lastname, id },
  } = props?.auth_status;
  const { customer: { id: organizationId } = {} } = props?.company_info;
  const username = `${firstname}  ${lastname}`;

  return { id: props?.share?.storage_id, organizationId, username, userId: id };
}

function submit(
  setActivePageIndex,
  setModalContent,
  inputs,
  setCaseId,
  change,
  props,
  ticketType
) {
  const button = (
    <BloxButton
      className="buttons41"
      id="okay"
      text="OKAY"
      module="storage"
      enabled={true}
      onClick={() => {}}
      cypressId="okay"
    />
  );

  const params = formatDeleteParams(props);
  StorageApi.deleteStorage(params)
    .then((response) => {
      if (response.status === 200 && response.data.deleted) {
        setActivePageIndex(2);
        if (ticketType?.bonita) {
          setCaseId(response.data.caseId);
        }
        props?.getShares();
      } else {
        setModalContent(
          "TIMEOUT_CLOSE",
          "Network error deleting storage",
          button
        );
      }
    })
    .catch(() => {
      if (ticketType?.bonita) {
        createDeleteStorageTicket(
          props,
          setModalContent,
          setCaseId,
          setActivePageIndex,
          button
        );
      }
    });
}

function getButtonFunction2(activePage, setActivePageIndex, inputs) {
  if (activePage === 3 && !inputs?.redundancy) {
    return () => setActivePageIndex(activePage - 2);
  } else if (setActivePageIndex && activePage !== 0 && activePage !== 4) {
    return () => setActivePageIndex(activePage - 1);
  } else {
    return null;
  }
}
function formatDeleteDescription(storage, auth_status) {
  const {
    user: { firstname, lastname },
  } = auth_status;
  let description = "";
  description += `Share Name: ${storage.common_name}\n `;
  description += `Share ID: ${storage?.storage_id}\n `;
  description += `Requestor: ${firstname}  ${lastname} \n`;

  // Add shared user information if available
  const sharedUserData = sessionStorage.getItem("sharedUser");
  if (sharedUserData) {
    const { name, email } = JSON.parse(sharedUserData);
    description += `Shared User Name: ${name}\n`;
    description += `Shared User Email: ${email}\n`;
  }

  description += `Time: ${format(new Date(), "HH:mm")}`;
  return description;
}

const DeleteStorageModal = (props) => {
  const share = props?.share;
  const breakpoint = props?.breakpoint;
  const setModalContent = props?.setModalContent;
  const closeModal = props?.closeModal;
  const { activePageIndex, setActivePageIndex } = useActiveScreen(0);
  const [caseId, setCaseId] = useState(null);
  const { inputs, change } = useContext(DeleteStorageDataContext);
  const Screen = SCREENS[activePageIndex];
  const ticketType = props?.ticketType;

  const buttonText = getButtonText(inputs, activePageIndex);
  function resetModal() {
    change({ target: { name: "name", value: "" } });
    change({ target: { name: "share", value: null } });
    change({ target: { name: "submitted", value: false } });

    closeModal();
    setActivePageIndex(0);
  }

  const SUBTITLE = {
    0: "Are you sure you want to delete this storage ?",
    1: `Delete ${share?.common_name}`,
    2: "Success!",
  };
  const TITLE = {
    0: "",
    1: "We know this is a pain, but this is your last chance to turn back.",
    2: `You've successfully deleted ${share?.common_name} `,
  };

  function getHeader(index) {
    return (
      <ModalHeader
        image={
          "https://test.mydcblox.com/cdn/library/storage/Storage-object-icon-transparent.svg"
        }
        text={TITLE[index]}
        className="storage-add"
      />
    );
  }

  return (
    <PortraitModalComponent
      closeModal={resetModal}
      show={props?.showModal}
      header={getHeader(activePageIndex)}
      title="DELETE STORAGE REQUEST"
      subTitle={SUBTITLE[activePageIndex]}
      size={getSize(breakpoint)}
      breakpoint={breakpoint}
    >
      <Screen
        activePageIndex={activePageIndex}
        setActivePageIndex={setActivePageIndex}
        caseId={caseId}
        resetModal={resetModal}
        share={share}
        navigate={props?.navigate}
      />
      <ModalFooter
        cypressId="footer"
        id="footer"
        buttonText1={buttonText}
        buttonText2="Back"
        buttonActive1={checkValidation(activePageIndex, inputs)}
        buttonActive2={!inputs?.submitted}
        module="storage"
        buttonFunction1={getButtonFunction(
          buttonText,
          activePageIndex,
          setActivePageIndex,
          setModalContent,
          inputs,
          setCaseId,
          change,
          props,
          ticketType
        )}
        size={getSize(breakpoint)}
        buttonFunction2={getButtonFunction2(
          activePageIndex,
          setActivePageIndex,
          inputs
        )}
      />
    </PortraitModalComponent>
  );
};

function mapStateToProps(state) {
  return {
    site: state.site_tracking,
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps)(DeleteStorageModal);

DeleteStorageModal.propTypes = {
  closeModal: func.isRequired,
  breakpoint: string.isRequired,
  showModal: bool.isRequired,
  id: string,
  setModalContent: func.isRequired,
};

DeleteStorageModal.defaultProps = {};
